module.exports = __webpack_public_path__ + "img/symphony_775_jeans.3bf527d3.jpg";